<template>
  <a-layout class='s_bf'>
      <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-item ref="real_name" label="姓名" name="real_name">
          <a-row :gutter="16">
            <a-col :span="16">
              <a-input v-model:value="form.real_name" placeholder='请输入姓名' :maxlength="10" />
            </a-col>
            <a-col :span="8">
              <p>最多10个字</p>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item ref="mobile" label="手机号" name="mobile">
          <a-row :gutter="16">
            <a-col :span="16">
              <a-input v-model:value="form.mobile" placeholder='请输入手机号' :maxlength="11" v-inputFilter:phone/>
            </a-col>
            <a-col :span="8">
              <p>11位手机号码</p>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item ref="birthday" label="生日" name="birthday">
          <a-row :gutter="16">
            <a-col :span="16">
              <!-- <a-input v-model:value="form.birthday" placeholder='请输入生日，例1998-05-20' /> -->
               <a-date-picker v-model:value="form.birthday"  valueFormat='YYYY-MM-DD' format='YYYY-MM-DD'/>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item ref="province_id" label="所在地区" name="province_id">
          <a-row :gutter="16">
            <a-col :span="16">
              <selectCity v-on:citychange='(e,s)=>{form.province_id = e[0];form.city_id = e[1];form.district_id = e[2]}' :addressData='addressData' placeholder='请选择所在地区'></selectCity>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item ref="wechat_number" label="微信号" name="wechat_number">
          <a-row :gutter="16">
            <a-col :span="16">
              <a-input v-model:value="form.wechat_number" placeholder='请输入微信号' />
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 8, offset: 4 }">
          <a-button type="primary" @click="onSubmit">
            保存
          </a-button>
        </a-form-item>
      </a-form>
  </a-layout>
</template>
<script>
  import { ref, onMounted, reactive, toRefs, inject } from 'vue';
  import { message } from 'ant-design-vue';
  import { iscode } from "@/utils/app";
  import { editUser } from '@/api/member'
  // 初始化默认筛选项数值
  let defForm = {
    real_name:'',
    province_id:'',
    city_id:'',
    district_id:'',
    mobile: '',
    wechat_number:'',
    birthday:'',
  }
  export default {
    name: 'userEdit',
    components: {},
    props: {
      formData: {
        type: Object
      },
    },
    setup(props, { emit }) {
      //pass
      const form = ref({ ...defForm });
      const state = reactive({
        labelCol: { span: 4 },
        wrapperCol: { span: 20 },
        formData:{},
        addressData:[]
      });
      const ruleForm = ref()
      const onSubmit = async() => {
          let res = await editUser(form.value).then((res) => res.data).catch(error => error);
          if (iscode(res)) {
            message.success(res.msg);
            emit('onsubmit')
          }else{
            message.error(res.msg);
          }
      }

      onMounted(() => {
        form.value = props.formData
        if(form.value.province_id && form.value.city_id && form.value.district_id){
          state.addressData = [form.value.province_id,form.value.city_id,form.value.district_id]
        }
      });
      return {
        form,
        ...toRefs(state),
        ruleForm,
        onSubmit,
      }
    }
  }
</script>
